var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemStoryFilledDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#222324",
  d: "M13.28 14.74c-.335.204-1.283.375-2.014.174a3.5 3.5 0 0 1-1.39-.805 1 1 0 0 0-1.4 1.43 5.46 5.46 0 0 0 2.26 1.303c.393.108.829.16 1.27.16.858 0 1.73-.197 2.319-.557.82-.503 1.33-1.325 1.396-2.257.052-.759-.158-2.137-2.22-2.859l-2.653-.72c-.337-.102-.52-.332-.515-.647.003-.209.008-.599.714-.788.655-.178 1.259-.012 1.488.066.256.088.539.26.779.47a1.001 1.001 0 0 0 1.319-1.504 4.5 4.5 0 0 0-1.446-.857c-.5-.17-1.514-.416-2.658-.107-1.358.364-2.18 1.371-2.196 2.692-.018 1.211.742 2.227 1.964 2.597l2.61.706c.854.3.83.635.819.813q-.032.436-.446.69"
}))));
export default SvgGemStoryFilledDark;